// T4/100A01: Menú lateral izquierdo compartido (inicio y submódulos).
// - Sin `collapsible` produce el MISMO marcado que components/home/index.js:89-116.
// - Con `collapsible` agrega el botón ocultar/mostrar; oculto queda como barra de
//   iconos (56 px) con el nombre en un tooltip.
import "./sidebar.css";
import React from "react";
import { Tooltip } from "antd";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";

const SidebarItem = ({ item, active, collapsed, onSelect }) => {
  const node = (
    <div
      role="button"
      tabIndex={0}
      aria-label={item.name}
      className={`jag-sidebar-item ${active === item.key ? "active" : ""} ${item.isGlobal ? "global" : ""}`}
      onClick={() => onSelect(item.key)}
      onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onSelect(item.key)}
    >
      <span className="jag-sidebar-icon">{item.icon}</span>
      {!collapsed && <span className="jag-sidebar-label">{item.name}</span>}
    </div>
  );
  return collapsed ? (
    <Tooltip title={item.name} placement="right">
      {node}
    </Tooltip>
  ) : (
    node
  );
};

const AppSidebar = ({ tabs, active, onSelect, collapsible = false, collapsed = false, onToggle }) => {
  const isCollapsed = collapsible && collapsed;
  const items = (list) =>
    (list || []).map((item) => (
      <SidebarItem key={item.key} item={item} active={active} collapsed={isCollapsed} onSelect={onSelect} />
    ));

  return (
    // T4/100A03: + clase jag-app-sidebar (solo este menú; el del inicio sin variable no la tiene).
    <div className={`jag-sidebar jag-app-sidebar ${collapsible ? "jag-sidebar--collapsible" : ""} ${isCollapsed ? "jag-sidebar--collapsed" : ""}`}>
      <div className="jag-sidebar-sections">
        {collapsible && (
          <button
            type="button"
            className="jag-sidebar-toggle"
            aria-label={isCollapsed ? "Mostrar menú" : "Ocultar menú"}
            onClick={onToggle}
          >
            {isCollapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          </button>
        )}
        <div className="jag-sidebar-group">
          {!isCollapsed && <div className="jag-sidebar-group-label">Departamentos</div>}
          {items(tabs.main)}
        </div>

        <div className="jag-sidebar-divider" />

        <div className="jag-sidebar-group">
          {!isCollapsed && <div className="jag-sidebar-group-label">Global</div>}
          {items(tabs.global)}
        </div>
      </div>

      <div className="jag-sidebar-bottom">{items(tabs.bottom)}</div>
    </div>
  );
};

export default AppSidebar;
